import { useRef, useState, useEffect } from "react";
import { quotationAPI } from "../../api/quotationAPI";

export default function CurrencyTypeSearch({ pCode, setCurrenyCode, setCurrencyName }) {
    const [allCurrency, setAllCurrency] = useState([]);

    const isFirstRender = useRef(false);

    const getCurrency = (searchKey = '') => {
        quotationAPI.getCurrency(pCode, searchKey).then((data) => {
            setAllCurrency(data);
        })
    }

    const handleRowSelect = (code, name) => {
        setCurrenyCode(code);
        setCurrencyName(name);
    }

    useEffect(() => {
        if (!isFirstRender.current) {
            isFirstRender.current = true;
            getCurrency()
        }
    }, []);

    return (
        <>
            <div className="modal fade" id="currencyTypeSearch" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Currency</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                            <input type="text" className="form-control" placeholder="Search by code or name"
                                onChange={(e) => getCurrency(e.target.value)}
                            />
                            <table className="table mt-1">
                                <thead className="thead--color">
                                    <tr>
                                        <th scope="col">Code</th>
                                        <th scope="col">Name</th>
                                        <th className="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {allCurrency && allCurrency.map(data => (
                                        <tr key={data.code}>
                                            <td>{data.code}</td>
                                            <td>{data.name}</td>
                                            <td className="text-center"><button type="button" className="btn btn-sm btn-dark"
                                                onClick={() => handleRowSelect(data.code, data.name)} data-bs-dismiss="modal">
                                                Select</button></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div></>
    )
}